import { useAppContext } from '../context/AppContext';
import { fetchToken } from '../services';
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import darkLogo from '../assets/dark-logo.png';
import lightLogo from '../assets/light-logo.png';

export const LoginPage = ({ darkMode }) => {
  const { base_url, setToken, token, showStatus } = useAppContext();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (token) {
      navigate('/', { replace: true });
    }
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) {
      showStatus('error', 'Please enter your email and password.');
      return;
    }

    setLoading(true);
    let loginError = null;
    await fetchToken(email, password, base_url, setToken, (msg) => {
      loginError = msg;
      showStatus('error', msg);
    }, rememberMe);
    setLoading(false);
    if (!loginError) {
      showStatus('success', 'Welcome back!');
      navigate('/');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">
            <img
              src={darkMode ? darkLogo : lightLogo}
              alt=""
              width={48}
              height={48}
              decoding="async"
            />
          </div>
          <h1>Slipstream</h1>
          <p>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label" htmlFor="login-email">Email</label>
            <input
              id="login-email"
              className="form-input"
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoComplete="email"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="login-password">Password</label>
            <input
              id="login-password"
              className="form-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>

          <div className="login-remember">
            <label className="login-checkbox">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={e => setRememberMe(e.target.checked)}
              />
              <span>Remember me</span>
            </label>
            <Link to="/forgot-password" className="login-forgot-link">
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            className="btn btn-primary login-submit"
            disabled={loading}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <div className="login-divider">
          <span>or</span>
        </div>

        <a
          href="https://www.slipstreaminvoices.com/demo"
          className="login-create-account"
        >
          Create a new account
        </a>
      </div>
    </div>
  );
};
